import LocationSelectModal from './LocationSelectModal';

const warehouseManagement = {
  LocationSelectModal,
}
export default warehouseManagement;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/warehouseManagement/index.jsx